export default __webpack_public_path__ + "static/media/exito.e13cc84c.png";